/*global contactus*/

var isSendingForm = false;
window.VWO = window.VWO || [];

$(document).ready(function ($) {
    $('#loading_modal').click(function () {
        if (!isSendingForm) {
            $(this).modal('hide');
        }
    });

    $(this).on('keydown', function (e) {
        if (e.keyCode === 27 && !isSendingForm) {
            $('#loading_modal').modal('hide');
        }
    });

    $('.js-cu-form').submit(function (e) {
        e.preventDefault();

        isSendingForm = true;

        var form = $(this);

        // $('.modal.show').modal('hide');

        //Reset the loading modal
        var loadingTextElement = $('#loading_modal h2');
        loadingTextElement.hide();
        loadingTextElement.text(form.find('.js-success-message').val());
        $('.rotate-infinite').show();
        $('#loading_modal').modal();

        var data = {
            name: form.find('.js-name').val(),
            email: form.find('.js-email').val(),
            phone: form.find('.js-phone').val(),
            howCanWeHelp: form.find('.js-how-can-we-help').val(),
            page: form.find('.js-page').val(),
            action: 'process_contact_form',
        };

        $.post(contactus.ajax_url, data, function (response) {
            isSendingForm = false;
            $('.rotate-infinite').hide();

            if (response == 200) {
                //Reset the form
                form.trigger('reset');
                // $('#cu_modal').modal('hide');
                $('.js-error-text').text('Your information has been sent correctly.');
            }
            else {
                $('.js-error-text').text('Some error ocurred. Please try later.');
            }
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/contact-us.js